import { render, staticRenderFns } from "./TopParallax.vue?vue&type=template&id=6a109803"
import script from "./TopParallax.vue?vue&type=script&lang=js"
export * from "./TopParallax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports